import { render, staticRenderFns } from "./ProductImagePreview.vue?vue&type=template&id=1b263ac2&"
import script from "./ProductImagePreview.vue?vue&type=script&lang=js&"
export * from "./ProductImagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports